import { Injectable } from '@angular/core';

import { driver } from 'driver.js';

@Injectable({
  providedIn: 'root',
})
export class TourService {
  startJobPostingTour() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    const key = `tour_${user.id}_jobPosting`;
    const tour = driver({
      showProgress: true,

      animate: true,

      allowClose: true,

      overlayColor: 'rgba(15,20,40,.78)',

      popoverClass: 'jw-tour',

      smoothScroll: true,

      stagePadding: 8,

      stageRadius: 12,

      nextBtnText: 'Next →',

      prevBtnText: '← Previous',

      doneBtnText: 'Finish 🎉',

      steps: [
        /* Welcome */
        {
          element: '.tour-page-title',

          popover: {
            title: '👋 Welcome to Job World',

            description:
              'This module allows recruiters to create, manage and publish jobs.',

            side: 'bottom',

            align: 'start',
          },
        },

        /* Post Job */
        {
          element: '.tour-post-job',

          popover: {
            title: '🚀 Post Job',

            description: 'Click here to create a new Job Posting.',

            side: 'bottom',

            align: 'center',
          },
        },

        /* Search */
        {
          element: '.tour-search',

          popover: {
            title: '🔍 Search Jobs',

            description:
              'Search jobs using title, skills, recruiter or location.',

            side: 'bottom',
          },
        },

        /* Filters */
        {
          element: '.tour-filter',

          popover: {
            title: '⚡ Filters',

            description:
              'Quickly filter Draft, Published, Approved and Closed jobs.',

            side: 'left',
          },
        },

        /* Export */
        {
          element: '.tour-export',

          popover: {
            title: '📥 Export Jobs',

            description: 'Download all jobs into an Excel file.',

            side: 'left',
          },
        },

        /* Bulk Upload */
        {
          element: '.tour-job-status',

          popover: {
            title: '📤 JD Status',

            description:
              'Use this option to control the visibility and availability of the job posting. • Open: Candidates can apply. • On Hold: Hiring is temporarily paused. • Closed: The position is no longer accepting applications.',

            side: 'bottom',
          },
        },

        /* Table */
        {
          element: '.tour-job-table',

          popover: {
            title: '📋 Job Listing',

            description: 'All jobs created in the system will appear here.',

            side: 'top',
          },
        },

        /* Comments */
        {
          element: '.tour-comment',

          popover: {
            title: '💬 Recruiter Comments',

            description: 'View and manage recruiter discussions.',

            side: 'left',
          },
        },

        /* Actions */
        {
          element: '.tour-actions',

          popover: {
            title: '⚙️ Actions',

            description:
              'Edit, Assign Recruiters, Delete, Download JD and create exam rounds for candidates.',

            side: 'left',
          },
        },
      ],

      onDestroyed: (_element, _step, opts) => {
        this.completeTour('jobPosting', opts);
      },
    });

    tour.drive();
  }

  startViewDetailsTour() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const isRecruiter = user?.role === 'Recruiter';

    const key = `tour_${user.id}_jobPosting`;
    const tour = driver({
      showProgress: true,

      animate: true,

      smoothScroll: true,

      allowClose: true,

      overlayColor: 'rgba(15,20,40,.82)',

      popoverClass: 'jw-tour',

      nextBtnText: 'Next →',

      prevBtnText: '← Previous',

      doneBtnText: 'Finish 🎉',

      steps: [
        {
          element: '.tour-job-title',

          popover: {
            title: '📌 Job Title',

            description: 'Displays the selected Job Position.',

            side: 'bottom',
          },
        },

        {
          element: '.tour-job-status',

          popover: {
            title: '📤 Job Status',

            description:
              'Shows the current hiring stage. Open jobs accept applications, On Hold temporarily pauses hiring, and Closed jobs no longer accept candidates.',

            side: 'left',
          },
        },

        {
          element: '.tour-job-card',

          popover: {
            title: '💼 Job Summary',

            description:
              'Quick overview of experience, vacancies, location and company information.',

            side: 'bottom',
          },
        },
        {
          element: '.tour-upload-cv',

          popover: {
            title: '📤 Upload Resume',

            description:
              'Upload candidate resumes manually for this job posting.',

            side: 'bottom',
          },
        },

        {
          element: '.tour-rank-cv',

          popover: {
            title: '🤖 AI Resume Ranking',

            description:
              'Analyze uploaded resumes and rank candidates based on JD matching.',

            side: 'bottom',
          },
        },

        {
          element: '.tour-search-candidate',

          popover: {
            title: '🔍 Search Candidates',

            description: 'Search applicants by name, email or phone number.',

            side: 'bottom',
          },
        },

        {
          element: '.tour-candidate-table',

          popover: {
            title: '👥 Candidate Applications',

            description:
              'Displays all applicants, rankings, scores and actions.',

            side: 'top',
          },
        },

        {
          element: '.tour-ranking-details',

          popover: {
            title: '📊 Ranking Details',

            description:
              'View AI analysis, strengths, weaknesses and matching skills.',

            side: 'left',
          },
        },

        {
          element: '.tour-view-resume',

          popover: {
            title: '👁 View Resume',

            description: 'Open and review the candidate resume.',

            side: 'left',
          },
        },

        {
          element: '.tour-download-resume',

          popover: {
            title: '⬇ Download Resume',

            description: 'Download candidate resume locally.',

            side: 'left',
          },
        },

        {
          element: '.tour-candidate-selection',
          popover: {
            title: isRecruiter
              ? '📩 Select Candidates'
              : '✅ Shortlist Candidates',

            description: isRecruiter
              ? 'Select one or more approved candidates using these checkboxes, then click "Send Exam Invite" to email the assigned assessment. Only approved candidates can be selected.'
              : 'Use these checkboxes to shortlist approved candidates. Once shortlisted, click "Notify Recruiter" to inform the recruiter which candidates are ready for the exam process.',

            side: 'right',
          },
        },

        {
          element: '.tour-post-exam',

          popover: {
            title: '🧾 Candidate Onboarding',

            description: 'Manage Interview, Offer and Onboarding activities.',

            side: 'left',
          },
        },
        {
          popover: {
            title: '🎉 Tour Completed',

            description:
              'You are now ready to efficiently manage Job Details, Resume Ranking and Candidate Onboarding within Job World.',
          },
        },
      ],

      onDestroyed: (_element, _step, opts) => {
        this.completeTour('viewDetails', opts);
      },
    });

    tour.drive();
  }

  startRoundDetailsTour() {
    const tour = driver({
      showProgress: true,
      animate: true,
      smoothScroll: true,
      allowClose: true,

      overlayColor: 'rgba(15,20,40,.82)',
      popoverClass: 'jw-tour',

      nextBtnText: 'Next →',
      prevBtnText: '← Previous',
      doneBtnText: 'Finish 🎉',

      steps: [
        /* Header */

        {
          element: '.tour-round-title',

          popover: {
            title: '🏆 Round Management',

            description:
              'Manage all interview rounds for this Job Posting from a single place.',

            side: 'bottom',
          },
        },

        /* Create Round */

        {
          element: '.tour-create-round',

          popover: {
            title: '➕ Create Round',

            description:
              'Click here to configure a new assessment round such as Exam, Practice Test or Interview.',

            side: 'left',
          },
        },

        /* Search */

        {
          element: '.tour-search-round',

          popover: {
            title: '🔍 Search Rounds',

            description:
              'Quickly find rounds by type, number or assigned evaluator.',

            side: 'bottom',
          },
        },

        /* Table */

        {
          element: '.tour-round-table',

          popover: {
            title: '📋 Round Listing',

            description:
              'All configured rounds for this job posting are displayed here.',

            side: 'top',
          },
        },

        /* Round Type */

        {
          element: '.tour-round-type',

          popover: {
            title: '🎯 Round Type',

            description:
              'Each round can be configured as an Exam, Practice Test, Manual Interview or AI Interview.',

            side: 'left',
          },
        },

        /* Assigned */

        // {
        //   element: '.tour-assigned',

        //   popover: {
        //     title: '👤 Assigned To',

        //     description:
        //       'Shows the person, interviewer or bot responsible for conducting this round.',

        //     side: 'left',
        //   },
        // },

        /* Actions */

        {
          element: '.tour-round-actions',

          popover: {
            title: '⚙️ Round Actions',

            description:
              'View complete round details or permanently delete a round if it is no longer required.',

            side: 'left',
          },
        },

        /* Dialog */

        // {
        //   element: '.tour-round-dialog',

        //   popover: {
        //     title: '📝 Create New Round',

        //     description:
        //       'Select the round number and choose the assessment type to build your hiring workflow step-by-step.',

        //     side: 'left',
        //   },
        // },

        /* Finish */

        {
          popover: {
            title: '🎉 Tour Completed',

            description:
              'You are now ready to configure hiring pipelines, create interview stages and manage candidate evaluations efficiently.',
          },
        },
      ],

      onDestroyed: (_element, _step, opts) => {
        this.completeTour('roundDetails', opts);
      },
    });

    tour.drive();
  }

  startExamDetailsTour() {
    const tour = driver({
      showProgress: true,
      animate: true,
      smoothScroll: true,
      allowClose: true,

      overlayColor: 'rgba(15,20,40,.82)',
      popoverClass: 'jw-tour',

      nextBtnText: 'Next →',
      prevBtnText: '← Previous',
      doneBtnText: 'Finish 🎉',

      steps: [
        {
          element: '.tour-exam-title',
          popover: {
            title: '📝 Exam Management',
            description:
              'Manage online assessments for this interview round from one place.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-create-exam',
          popover: {
            title: '➕ Create Exam',
            description:
              'Create a new online assessment for this interview round.',
            side: 'left',
          },
        },

        {
          element: '.tour-search-exam',
          popover: {
            title: '🔍 Search Exams',
            description:
              'Quickly search exams by Job Title, Round Type or Assigned Title.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-exam-table',
          popover: {
            title: '📋 Exam List',
            description: 'All exams created for this round are displayed here.',
            side: 'top',
          },
        },

        {
          element: '.tour-assign-question',
          popover: {
            title: '📚 Assign Questions',
            description:
              'Assign questions, test pools and question variants to the selected exam.',
            side: 'left',
          },
        },

        {
          element: '.tour-exam-actions',
          popover: {
            title: '⚙️ Exam Actions',
            description:
              'View exam details, edit configuration or delete the exam.',
            side: 'left',
          },
        },

        {
          popover: {
            title: '🎉 Tour Completed',
            description:
              'You are now ready to create exams, assign questions and manage online assessments efficiently.',
          },
        },
      ],

      onDestroyed: (_element, _step, opts) => {
        this.completeTour('examManagement', opts);
      },
    });

    tour.drive();
  }

  startQuestionsDetailsTour() {
    const tour = driver({
      showProgress: true,
      animate: true,
      allowClose: true,
      smoothScroll: true,

      overlayColor: 'rgba(15,20,40,.82)',
      popoverClass: 'jw-tour',

      nextBtnText: 'Next →',
      prevBtnText: '← Previous',
      doneBtnText: 'Finish 🎉',

      steps: [
        {
          element: '.tour-question-title',
          popover: {
            title: '📝 Question Management',
            description:
              'This page allows you to fetch, review, select and assign questions to the current exam.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-selected-count',
          popover: {
            title: '✅ Selected Questions',
            description:
              'This counter displays how many questions you have currently selected. The total should match the required number before assignment.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-fetch-questions',
          popover: {
            title: '🔄 Fetch Questions',
            description:
              'Click here to automatically load questions based on the exam difficulty, skills and required question count.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-question-table',
          popover: {
            title: '📋 Question List',
            description:
              'Review every question along with its skill, difficulty, options and correct answer before selecting it.',
            side: 'top',
          },
        },

        {
          element: '.tour-select-all',
          popover: {
            title: '☑️ Select Questions',
            description:
              'Use this checkbox to quickly select or deselect all available questions. You can also select individual questions using the checkbox beside each question. After selecting the required number of questions, click "Assign Questions" to map them to the exam.',
            side: 'right',
            align: 'center',
          },
        },

        {
          element: '.tour-assign-questions',
          popover: {
            title: '📚 Assign Questions',
            description:
              'Once the required number of questions has been selected, click here to assign them permanently to the exam.',
            side: 'left',
          },
        },

        {
          popover: {
            title: '🎉 Tour Completed',
            description:
              'You are now ready to fetch, review and assign questions to your exam. Only the selected questions will be used during candidate assessments.',
          },
        },
      ],
      onDestroyed: (_element, _step, opts) => {
        this.completeTour('questionsManagement', opts);
      },
    });

    tour.drive();
  }

  startUserManagementTour() {
    const tour = driver({
      showProgress: true,
      animate: true,
      allowClose: true,
      smoothScroll: true,

      overlayColor: 'rgba(15,20,40,.82)',
      popoverClass: 'jw-tour',

      nextBtnText: 'Next →',
      prevBtnText: '← Previous',
      doneBtnText: 'Finish 🎉',

      steps: [
        {
          element: '.tour-user-title',
          popover: {
            title: '👥 User Management',
            description:
              'This page allows administrators to manage all registered users, review approval requests and monitor user status.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-user-tabs',
          popover: {
            title: '📂 User Categories',
            description:
              'Switch between All Users, Pending Requests and Approved users to quickly manage different user groups.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-user-search',
          popover: {
            title: '🔍 Search Users',
            description:
              'Search users by name, email or role to quickly find specific records.',
            side: 'left',
          },
        },

        {
          element: '.tour-user-table',
          popover: {
            title: '📋 User List',
            description:
              'View all user details including username, email, assigned role and current approval status.',
            side: 'top',
          },
        },

        {
          element: '.tour-user-actions',
          popover: {
            title: '✅ Approve or Reject Requests',
            description:
              'When viewing Pending Requests, use these action buttons to approve new users or reject their registration requests.',
            side: 'left',
          },
        },

        {
          popover: {
            title: '🎉 Tour Completed',
            description:
              "You are now ready to manage users, review approval requests, search records and efficiently administer your organization's users.",
          },
        },
      ],

      onDestroyed: (_element, _step, opts) => {
        this.completeTour('userManagement', opts);
      },
    });

    tour.drive();
  }

  startCndProfileTour() {
    const tour = driver({
      showProgress: true,
      animate: true,
      allowClose: true,
      smoothScroll: true,

      overlayColor: 'rgba(15,20,40,.82)',
      overlayOpacity: 0,
      popoverClass: 'jw-tour',

      nextBtnText: 'Next →',
      prevBtnText: '← Previous',
      doneBtnText: 'Finish 🎉',

      steps: [
        {
          element: '.tour-profile-title',
          popover: {
            title: '👋 Welcome to Profile Completion',
            description:
              'Complete your profile to improve your visibility and increase your chances of getting shortlisted by recruiters.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-profile-progress',
          popover: {
            title: '📈 Profile Completion',
            description:
              'Track your profile completion percentage and visibility status. Completing more sections increases your profile strength.',
            side: 'left',
          },
        },

        {
          element: '.tour-profile-tabs',
          popover: {
            title: '📂 Profile Sections',
            description:
              'Navigate between Resume, Personal Details, Education, Experience, Skills, Projects, Certifications, Documents and Job Preferences.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-upload-cv',
          popover: {
            title: '📄 Upload Resume',
            description:
              'Upload your latest resume by dragging and dropping it or selecting it from your device.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-ai-resume',
          popover: {
            title: '✨ AI Resume Builder',
            description:
              'Create a professional ATS-friendly resume using AI if you do not already have one.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-uploaded-cv',
          popover: {
            title: '📑 Uploaded Resumes',
            description:
              'View, download or delete your previously uploaded resumes.',
            side: 'top',
          },
        },

        {
          element: '.tour-basic-info',
          popover: {
            title: '👤 Basic Information',
            description:
              'Enter your personal details including name, phone number, gender and date of birth.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-address',
          popover: {
            title: '🏠 Address',
            description:
              'Provide your current residential address including city, state and country.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-professional-details',
          popover: {
            title: '💼 Professional Details',
            description:
              'Specify your experience, salary expectations, notice period and candidate type.',
            side: 'top',
          },
        },

        {
          element: '.tour-social-links',
          popover: {
            title: '🔗 Social Profiles',
            description:
              'Add your LinkedIn, GitHub and Portfolio links to showcase your professional work.',
            side: 'top',
          },
        },

        {
          element: '.tour-profile-summary',
          popover: {
            title: '📝 Profile Summary',
            description:
              'Write a professional summary about yourself or use AI to enhance it.',
            side: 'left',
          },
        },

        {
          element: '.tour-profile-picture',
          popover: {
            title: '📸 Profile Picture',
            description:
              'Upload a professional profile picture to make your profile more attractive.',
            side: 'right',
          },
        },

        {
          element: '.tour-education-card',
          popover: {
            title: '🎓 Education',
            description:
              'Add your educational qualifications, institution, university and academic performance.',
            side: 'top',
          },
        },

        {
          element: '.tour-add-education',
          popover: {
            title: '➕ Add Education',
            description:
              'Click here to add multiple educational qualifications.',
            side: 'top',
          },
        },

        {
          element: '.tour-experience-card',
          popover: {
            title: '💼 Work Experience',
            description:
              'Add your employment history, designation, responsibilities and achievements.',
            side: 'top',
          },
        },

        {
          element: '.tour-add-experience',
          popover: {
            title: '➕ Add Experience',
            description:
              'Add multiple organizations if you have worked at more than one company.',
            side: 'top',
          },
        },

        {
          element: '.tour-skills',
          popover: {
            title: '🛠 Skills',
            description:
              'Maintain your technical and professional skills to improve recruiter matching.',
            side: 'top',
          },
        },

        {
          element: '.tour-skill-search',
          popover: {
            title: '🔍 Search Skills',
            description:
              'Search from existing skills or add your own by typing and pressing Enter.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-selected-skills',
          popover: {
            title: '⭐ Selected Skills',
            description:
              'Update proficiency, experience and last used information for each skill.',
            side: 'top',
          },
        },

        {
          element: '.tour-project-card',
          popover: {
            title: '📂 Projects',
            description:
              'Showcase your projects, technologies used and project descriptions.',
            side: 'top',
          },
        },

        {
          element: '.tour-add-project',
          popover: {
            title: '➕ Add Project',
            description: 'Add multiple projects to strengthen your profile.',
            side: 'top',
          },
        },

        {
          element: '.tour-certification-card',
          popover: {
            title: '🏅 Certifications',
            description:
              'Add your professional certifications with issuing organization and credential details.',
            side: 'top',
          },
        },

        {
          element: '.tour-add-certification',
          popover: {
            title: '➕ Add Certification',
            description: 'Include all certifications relevant to your career.',
            side: 'top',
          },
        },

        {
          element: '.tour-document-card',
          popover: {
            title: '📄 Documents',
            description:
              'Upload achievements, awards and supporting documents to strengthen your profile.',
            side: 'top',
          },
        },

        {
          element: '.tour-add-document',
          popover: {
            title: '➕ Add Document',
            description:
              'Upload multiple supporting documents whenever required.',
            side: 'top',
          },
        },

        {
          element: '.tour-job-preferences',
          popover: {
            title: '🎯 Job Preferences',
            description:
              'Specify your preferred job role, industry, salary expectations, work locations and employment type.',
            side: 'top',
          },
        },

        {
          element: '.tour-prev-btn',
          popover: {
            title: '⬅ Previous',
            description:
              'Go back to the previous profile section without losing your saved information.',
            side: 'top',
          },
        },

        {
          element: '.tour-next-btn',
          popover: {
            title: '💾 Save & Continue',
            description:
              'Save the current section and continue to the next step. On the final step this button completes your profile.',
            side: 'top',
          },
        },

        {
          popover: {
            title: '🎉 Tour Completed',
            description:
              'Congratulations! Your profile is ready. Keep it updated to improve recruiter visibility and increase your chances of getting shortlisted.',
          },
        },
      ],

      onDestroyed: (_element, _step, opts) => {
        this.completeTour('candidateProfile', opts);
      },
    });

    tour.drive();
  }

  startResumeBuilderTour() {
    const tour = driver({
      showProgress: true,
      animate: true,
      allowClose: true,
      smoothScroll: true,

      overlayColor: 'rgba(15,20,40,.82)',
      popoverClass: 'jw-tour',

      nextBtnText: 'Next →',
      prevBtnText: '← Previous',
      doneBtnText: 'Finish 🎉',

      steps: [
        {
          element: '.tour-resume-header',
          popover: {
            title: '🚀 Resume Builder',
            description:
              'Welcome to the Resume Builder. Create a professional, ATS-friendly resume by selecting a template, customizing your details and downloading it as a PDF.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-resume-back',
          popover: {
            title: '⬅ Back',
            description:
              'Return to the previous page without making any changes to your current resume.',
            side: 'right',
          },
        },

        {
          element: '.tour-resume-intro',
          popover: {
            title: '📄 Resume Overview',
            description:
              'This section explains how the Resume Builder works and guides you through creating a professional resume in just a few steps.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-start-building',
          popover: {
            title: '✨ Start Building',
            description:
              'Click here to scroll directly to the available resume templates and begin creating your resume.',
            side: 'top',
          },
        },

        {
          element: '.tour-resume-stats',
          popover: {
            title: '📊 Resume Statistics',
            description:
              'View the number of resumes you have saved along with the available premium resume templates.',
            side: 'left',
          },
        },

        {
          element: '.tour-resume-stepper',
          popover: {
            title: '🛠 Resume Creation Process',
            description:
              'Building your resume is completed in three simple steps: Select a template, customize your information, and download the final PDF.',
            side: 'top',
          },
        },

        {
          element: '.tour-template-section',
          popover: {
            title: '📑 Resume Templates',
            description:
              'Browse professionally designed, ATS-friendly resume templates. Select the design that best represents your professional profile.',
            side: 'top',
          },
        },

        {
          element: '.tour-template-header',
          popover: {
            title: '🎨 Choose a Template',
            description:
              'This is the first step of the resume creation process. Select one template to begin editing your resume.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-template-grid',
          popover: {
            title: '📋 Available Templates',
            description:
              'All available resume templates are displayed here. Click any template to start building your resume.',
            side: 'top',
          },
        },

        {
          element: '.tour-template-card',
          popover: {
            title: '⭐ ATS-Friendly Template',
            description:
              'Each template is optimized for Applicant Tracking Systems (ATS) and designed to improve recruiter readability.',
            side: 'right',
          },
        },

        {
          element: '.tour-template-preview',
          popover: {
            title: '👀 Preview Template',
            description:
              'Preview the complete resume layout before selecting it. This helps you choose the design that best fits your profile.',
            side: 'left',
          },
        },
        {
          popover: {
            title: '🎉 Tour Completed',
            description:
              'Congratulations! Your profile is ready. Keep it updated to improve recruiter visibility and increase your chances of getting shortlisted.',
          },
        },
      ],

      onDestroyed: (_element, _step, opts) => {
        this.completeTour('resumeBuilder', opts);
      },
    });

    tour.drive();
  }

  startResumeBuilderTour2() {
    const tour = driver({
      showProgress: true,
      animate: true,
      allowClose: true,
      smoothScroll: true,

      overlayColor: 'rgba(15,20,40,.82)',
      popoverClass: 'jw-tour',

      nextBtnText: 'Next →',
      prevBtnText: '← Previous',
      doneBtnText: 'Finish 🎉',

      steps: [
        {
          element: '.tour-preview-topbar',
          popover: {
            title: '🛠 Resume Toolbar',
            description:
              'This toolbar provides quick access to navigation, editing and saving your resume.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-back-btn',
          popover: {
            title: '⬅ Back',
            description:
              'Return to the previous page without losing your saved resume.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-edit-btn',
          popover: {
            title: '✏ Edit Resume',
            description:
              'Enable editing mode to modify your resume content. Lock it again when you are finished.',
            side: 'bottom',
          },
        },

        {
          element: '.tour-save-download-btn',
          popover: {
            title: '💾 Save & Download',
            description:
              'Save your latest changes and download your resume as a professional PDF.',
            side: 'left',
          },
        },

        {
          element: '.tour-resume-canvas',
          popover: {
            title: '✨ Interactive Resume Canvas',
            description:
              'Click directly on sections like your name, summary, experience, education, skills, or projects to edit them. Every change is reflected in real time, allowing you to see exactly how your final resume will look.',
            side: 'left',
          },
        },

        {
          popover: {
            title: '🎉 Tour Completed',
            description:
              'Congratulations! Your profile is ready. Keep it updated to improve recruiter visibility and increase your chances of getting shortlisted.',
          },
        },
      ],

      onDestroyed: (_element, _step, opts) => {
        this.completeTour('resumeBuilder2', opts);
      },
    });

    tour.drive();
  }

  /* =====================================================================
     TOUR VISIBILITY WINDOW

     A tour runs on the user's very first visit to a screen, and then stays
     hidden for TOUR_REPEAT_MONTHS before it is offered again.

     Every component already gates on hasSeenTour(), so the rule lives here
     and applies everywhere at once - no component changes needed.
     ===================================================================== */

  /** How long a completed tour stays hidden before it is shown again. */
  private static readonly TOUR_REPEAT_MONTHS = 2;

  /** Prefix for every key this service owns. */
  private static readonly TOUR_KEY_PREFIX = 'tour_';

  /**
   * Stable per-user id.
   *
   * The 'user' object is written by three different login paths and one of
   * them can store the literal string "undefined", which makes JSON.parse
   * throw. Falling back to the flat 'user_id' key - written by all three -
   * keeps tour flags working for every role.
   */
  private currentUserId(): string {
    try {
      const raw = localStorage.getItem('user');

      if (raw && raw !== 'undefined' && raw !== 'null') {
        const parsed = JSON.parse(raw);

        if (parsed?.id !== undefined && parsed?.id !== null) {
          return String(parsed.id);
        }
      }
    } catch {
      // Malformed 'user' - fall through to user_id.
    }

    try {
      return localStorage.getItem('user_id') || 'anon';
    } catch {
      return 'anon';
    }
  }

  /** Per-user storage key for one tour. */
  private tourKey(tourName: string): string {
    return `${TourService.TOUR_KEY_PREFIX}${this.currentUserId()}_${tourName}`;
  }

  /**
   * Called from every tour's onDestroyed.
   *
   * Only a tour the user actually walked to the last step counts as seen.
   * Closing early - overlay click, Esc, the X button - leaves it pending so
   * it runs again next time, which is what a half-read tour deserves.
   *
   * driver.js resets its own state before onDestroyed runs, so the step index
   * has to come from the `state` snapshot it hands the hook, not from calling
   * back into the driver instance.
   */
  private completeTour(tourName: string, opts?: any): void {
    const steps = opts?.config?.steps || [];
    const activeIndex = opts?.state?.activeIndex;

    const reachedEnd =
      typeof activeIndex === 'number' &&
      steps.length > 0 &&
      activeIndex >= steps.length - 1;

    if (reachedEnd) {
      this.markTourCompleted(tourName);
    }
  }

  /* ---------------- Surviving logout ----------------
     AuthenticationService.logout() calls localStorage.clear(), and the HTTP
     interceptor calls it silently on any 401. Without this, every tour flag
     dies there and the tours replay on the next login. Keys are per-user, so
     restoring them is safe when somebody else signs in on the same browser. */

  /** Snapshot of every tour flag, for restoring around a storage wipe. */
  snapshotTours(): { [key: string]: string } {
    const snapshot: { [key: string]: string } = {};

    try {
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);

        if (key?.startsWith(TourService.TOUR_KEY_PREFIX)) {
          snapshot[key] = localStorage.getItem(key) || '';
        }
      }
    } catch {
      // Storage unavailable - nothing to preserve.
    }

    return snapshot;
  }

  /** Puts a snapshotTours() result back after the wipe. */
  restoreTours(snapshot: { [key: string]: string }): void {
    try {
      Object.keys(snapshot || {}).forEach((key) =>
        localStorage.setItem(key, snapshot[key]),
      );
    } catch {
      // Storage unavailable - the tours simply run again.
    }
  }

  /** The same calendar day, TOUR_REPEAT_MONTHS later. */
  private tourExpiry(takenAt: number): number {
    const due = new Date(takenAt);

    due.setMonth(due.getMonth() + TourService.TOUR_REPEAT_MONTHS);

    return due.getTime();
  }

  /** Stamps the moment the tour finished (or was closed). */
  markTourCompleted(tourName: string) {
    try {
      localStorage.setItem(this.tourKey(tourName), String(Date.now()));
    } catch {
      // Private mode / storage disabled - the tour simply runs again.
    }
  }

  /**
   * false -> show the tour (never taken, or the window has elapsed).
   * true  -> stay quiet.
   */
  hasSeenTour(tourName: string): boolean {
    let stored: string | null = null;

    try {
      stored = localStorage.getItem(this.tourKey(tourName));
    } catch {
      return false;
    }

    // Never taken: this is the user's first visit to the screen.
    if (!stored) {
      return false;
    }

    // Legacy 'true' written before timestamps existed. Stamp it now so users
    // who already dismissed the tour don't get a replay the day we deploy;
    // they follow the normal window from here.
    if (stored === 'true') {
      this.markTourCompleted(tourName);
      return true;
    }

    const takenAt = Number(stored);

    if (!takenAt || Number.isNaN(takenAt)) {
      return false;
    }

    return Date.now() < this.tourExpiry(takenAt);
  }

  /** Clears one tour so it runs again on the next visit. */
  resetTour(tourName: string): void {
    try {
      localStorage.removeItem(this.tourKey(tourName));
    } catch {
      // Nothing to clear.
    }
  }
}
